const transfers = {
  transfer: "Transfer",
  transfers: "Transfers",
  dateAndTime: "Date and Time",
  transferFrom: "Transfer From",
  duration: "Duration",
  numOfPersons: "Number of Persons",
  baggageAllowance: "Baggage Allowance",
  small: "Small",
  big: "Big",
  provider: "Provider",
  vehicle: "Vehicle",
  distance: "Distance",
  price: "Price",
  inboundJourney: "Inbound Journey",
  outboundJourney: "Outbound Journey",
  arrivalTime: "Arrival Time",
  flightDetails: "Flight Details",
  inboundPickupDate: "Inbound Pickup Date",
  outboundPickupDate: "Outbound Pickup Date",
  travelInfo: "Travel Info",
  flightsInfo: "Flights Info",
  airportYouAreFlyingFrom: "Airport you’re flying from",
  airportYouAreFlyingTo: "Airport you’re flying to",
  inboundFlightNumber: "Inbound Flight Number",
  outboundFlightNumber: "Outbound Flight Number",
  inboundAirlineName: "Inbound Airline Name",
  outboundAirlineName: "Outbound Airline Name",
  tripMode: "Trip Mode",
  airportToPoint: "Airport To Point",
  pointToAirport: "Point To Airport",
  roundTrip: "Round Trip",
  destinationPoint: "Destination Point",
  originPoint: "Origin Point",
  transferType: "Transfer Type",
  min: "Min",
  max: "Max",
  pieces: "Pieces",
  cancelationIs: "cancelation is",
};

export default transfers;
